import React from "react";

const TrainingDashboard = () => {
  return <div>TrainingDashboard</div>;
};

export default TrainingDashboard;
